// extracted by css-extract-rspack-plugin
var _1 = "O8lmE4m53CABPI3_";
export { _1 as "grid" }
